"use strict";

var googleCalendarAPI = require("app/util/api/google-calendar-api");
var SignalActions = require("app/shared/actions/signal-actions");
var integrationsAPI = require("app/util/api/integrations-api");
var Intl = require("intl");
var ReactIntl = require("react-intl");
var GoogleCalendarActivation = require("app/screens/Integration/components/GoogleCalendar/google-calendar-activation");
var GoogleCalendarIntegration =  require("app/screens/Integration/components/GoogleCalendar/google-calendar-integration");
var GoogleCalendarLoading =  require("app/screens/Integration/components/GoogleCalendar/google-calendar-loading");
var GoogleCalendarSettings =  require("app/screens/Integration/components/GoogleCalendar/google-calendar-settings");
var CalendarSelector = require("app/screens/Integration/components/GoogleCalendar/calendar-selector");

var GoogleCalendarIntegrationContainer = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    isFeatureAvailable: React.PropTypes.bool,
    isTrialDone: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      isFeatureAvailable: true,
      isTrialDone: true
    };
  },
  getInitialState: function() {
    return {
      viewSettings: (window.location.search.indexOf("gcSettings=on") > 0),
      isAfterActivationRedirect: (window.location.search.indexOf("gcSettings=on") > 0),
      credential: null,
      calendarList: [],
      email: "",
      hasIntegration: null,
      callingAPI: false
    };
  },
  componentDidMount: function() {
    this.getSettings();
  },
  getSettings: function() {
    integrationsAPI.get("/setting?include=credential", {},
      function (body, response) {
        var hasIntegration = (response.status == 200);
        this.setState({ hasIntegration: hasIntegration });
        if (hasIntegration) {
          var attributes = response.body;

          this.setIntegrationData(
            attributes.included[0].attributes.token_type,
            attributes.included[0].attributes.access_token,
            attributes.data.attributes.email,
            attributes.data.attributes.calendar
          );

          this.getAuthorization();
        }

        if (this.state.isAfterActivationRedirect) {
          this.showActivationRedirectMessage(hasIntegration);
        }

      }.bind(this));
  },
  setIntegrationData: function(type, authKey, email, selectedCalendar) {
    this.setState({
      credential: {type: type, authKey: authKey},
      email: email,
      selectedCalendar: selectedCalendar
    });
  },
  showActivationRedirectMessage: function(hasIntegration) {
    if (hasIntegration) {
      this.showSignal("Sua integração com o Google Agenda foi ativada.");
    } else {
      this.showSignal("Não foi possível ativar a integração com o Google Agenda.<br>" +
        "Por favor, verifique se ela foi ativada em uma outra conta com o email " +
        "informado no Google. Caso afirmativo, é necessário desativá-la primeiro.<br>" +
        "<a href=\"http://www.agendor.com.br/perguntas-frequentes/como-remover-a-integracao-do-google-calendar-com-o-agendor\" target=\"_blank\">" +
        "Veja como fazer este procedimento aqui</a>.", "warning", 30000);
    }
  },
  showSignal: function(message, type, hideTimeout) {
    SignalActions.show({
      message: message,
      type: type || "success",
      hideTimeout: hideTimeout || 5000
    });
  },
  getAuthorization: function() {
    var credential = this.state.credential;
    var options = {
      endpoint: "https://www.googleapis.com/calendar/v3/users/me/calendarList",
      credential: credential,
      onCompleted: function(error, response) {
        var attributes = response.body;
        this.setState({calendarList: attributes.items});
      }.bind(this)
    };
    googleCalendarAPI.request(options);
  },
  activateIntegration: function() {
    this.setState({callingAPI: true});
    integrationsAPI.get("/authorization_uri", {}, {
      success: function(response) {
        //Redirect to Google API Integration screen
        window.location = response.body.uri;
      },
      error: function(err) {
        this.setState({callingAPI: false});
        this.showSignal("Algo deu errado, tente novamente mais tarde.", "warning");
      }.bind(this)
    });
  },
  removeIntegration: function() {
    this.setState({callingAPI: true});
    integrationsAPI.del("/setting", {}, {
      success: function(response) {
        //Show message of removal
        this.setState({hasIntegration: false, callingAPI: false});
        this.showSignal("Integração removida com sucesso.");
        this.removeIntegrationStates();
      }.bind(this),
      error: function(err) {
        this.setState({callingAPI: false});
        this.showSignal("Algo deu errado, tente novamente mais tarde.", "warning");
      }.bind(this)
    });
  },
  setViewSettings: function(view) {
    this.setState({viewSettings: view});
  },
  removeIntegrationStates: function() {
    this.replaceState({
      viewSettings: false,
      callingAPI: false,
      email: "",
      hasIntegration: false
    });
  },
  setCalendar: function(obj) {
    this.setState({selectedCalendar: obj.value});
  },
  saveSettings: function() {
    integrationsAPI.put("/setting", { calendar: this.state.selectedCalendar }, {
      success: function(response) {
        this.showSignal("Configurações salvas com sucesso.");
      }.bind(this),
      error: function(err) {
        this.showSignal("Algo deu errado, tente novamente mais tarde.", "warning");
      }.bind(this)
    });
  },
  render: function() {
    return (
      <div>
      {( this.state.hasIntegration == null )?
        <GoogleCalendarLoading /> :
        <div className="mb40 bootstrap-agendor">
          <GoogleCalendarIntegration>
            <GoogleCalendarActivation
              email={this.state.email}
              hasIntegration={this.state.hasIntegration}
              callingAPI={this.state.callingAPI}
              handleActivate={this.activateIntegration}
              handleRemove={this.removeIntegration}
              handleViewSettings={this.setViewSettings}
              viewSettings={this.state.viewSettings}
              isFeatureAvailable={this.props.isFeatureAvailable}
              isTrialDone={this.props.isTrialDone}
            />
          </GoogleCalendarIntegration>
          {this.state.hasIntegration && this.state.viewSettings ?
            <GoogleCalendarSettings handleSave={this.saveSettings}>
              <CalendarSelector
                value={this.state.selectedCalendar}
                calendarList={this.state.calendarList}
                handleChange={this.setCalendar}/>
            </GoogleCalendarSettings> : null}
        </div>
         }
      </div>
    );
  }
});

module.exports = GoogleCalendarIntegrationContainer;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/google-calendar-integration-container.jsx